import { useEffect, useState } from 'react';
import { useProductState } from '../ProductProvider';

type Callback = () => void;

// 单例 IntersectionObserver
let observer: IntersectionObserver | null = null;
const listeners = new Map<Element, Callback>();

function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const cb = listeners.get(entry.target);
                    if (cb) {
                        cb();
                        listeners.delete(entry.target);
                        observer?.unobserve(entry.target);
                    }
                }
            });
        },
        {
            rootMargin: '200% 0px', // 提前两屏加载
            threshold: 0.01,
        },
    );
    return observer;
}

export const useWebpOrJpg = (selectors?: string) => {
    const { canWebp } = useProductState();
    const [flag, setFlag] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!selectors) {
            setFlag(true);
            return;
        }
        const el = document.querySelector(selectors);
        if (!el) return;

        const obs = getObserver();
        listeners.set(el, () => setFlag(true));
        obs.observe(el);

        return () => {
            listeners.delete(el);
            obs.unobserve(el);
        };
    }, [selectors]);

    return (jpg: string, webp?: string) => {
        if (!flag) return '';
        switch (canWebp) {
            case 1:
                return webp || jpg;
            case -1:
                return jpg;
            case 0:
            default:
                return '';
        }
    };
};
